import { DefaultTheme } from 'styled-components';

declare module 'styled-components' {
    interface DefaultTheme {
        fontSize: string[];
        widths: {
            innerSidebar: string;
        };
        colors: {
            white: string;
            black: string;
            primary: string[]
            state: {
                error: string;
            };
            gray: string[];
            brand: {
                facebook: string;
                instagram: string;
            };
        };
        spacing: string[];
        radius: {
            xs: string,
            sm: string;
            md: string;
            full: string;
        };
        shadows: {
            xs: string;
            sm: string;
            md: string;
            lg: string;
            xl: string;
        };
    }
}

export const Theme: DefaultTheme = {
    fontSize: [
        '0.8rem',
        '1rem',
        '1.25rem',
        '1.563rem',
        '1.953rem',
        '2.441rem',
        '3.052rem',
    ],
    widths: {
        innerSidebar: '360px',
    },
    colors: {
        white: '#fff',
        black: '#30302f',
        primary: [
            '#FFE7F6',
            '#FFCCED',
            '#FF99DB',
            '#CB0084',
            '#A9006E',

        ],
        state: {
            error: '#D92D20',
        },
        gray: [
            '#FAFAFA',
            '#EEE',
            '#DDDDDC',
            '#CCCCCB',
            '#BBBBB9',
            '#A9A9A8',
            '#767673',
            '#535351',
            '#30302F',
        ],
        brand: {
            facebook: '#4267B2',
            instagram: 'linear-gradient(45deg, #405de6, #5851db, #833ab4, #c13584, #e1306c, #fd1d1d)',
        },
    },
    spacing: [
        '0',
        '.25rem',
        '.5rem',
        '.75rem',
        '1rem',
        '1.25rem',
        '1.5rem',
        '2rem',
        '2.5rem',
        '3rem',
        '4rem',
        '5rem',
        '6rem',
        '8rem',
        '10rem',
        '12rem',
        '14rem',
        '16rem',
    ],
    radius: {
        xs: '0.25rem',
        sm: '0.375rem',
        md: '0.5rem',
        full: '6.25rem',
    },
    shadows: {
        xs: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
        sm: '0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06)',
        md: '0px 4px 8px -2px rgba(16, 24, 40, 0.10), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)',
        lg: '0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)',
        xl: '0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)',
    },
};
